// src/hooks/pricingUnits/useGetPricingUnit.js
import { useQuery } from "@tanstack/react-query";
import { getPricingUnit } from "../../api/apiPricingUnits";

const useGetPricingUnit = (id) => {
    const { isLoading, error, data } = useQuery({
        queryKey: ["pricingUnit", id],
        queryFn: () => getPricingUnit(id),
        enabled: !!id,
    });

    return {
        isLoading,
        error,
        pricingUnit: data?.data || null
    };
};

export default useGetPricingUnit;
